import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('app.core').factory('PrincipalEpdf', PrincipalEpdfData);

    function PrincipalEpdfData() {
        PrincipalEpdf.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            setLadProvider: setLadProvider,
            prepareForServer: prepareForServer
        };

        function PrincipalEpdf(principalEpdfData) {
            if (!principalEpdfData) {
                this.buildEmpty();
            } else {
                this.build(principalEpdfData);
            }
        }

        return PrincipalEpdf;

        /////////////////////

        function buildEmpty() {
            this.paramEpdf = false;
            this.ladProviderEid = null;
            this.sendRefLad = false;
            this.depositorControl = false;
            this.mailDomainNotif = false;
            this.domainName = '';
            this.pwd = '';
        }

        function build(principalEpdfData) {
            this.paramEpdf = true;
            this.ladProviderEid = principalEpdfData.ladProviderEid || null;
            this.sendRefLad = principalEpdfData.sendRefLad || null;
            this.depositorControl = principalEpdfData.depositorControl || false;
            this.mailDomainNotif = principalEpdfData.mailDomainNotif || false;
            this.domainName = principalEpdfData.domainName || '';
            this.pwd = principalEpdfData.pwd || '';
        }

        function setLadProvider(ladProviders) {
            if (this.ladProviderEid && ladProviders) {
                this.ladProvider = _.find(ladProviders, { eId: this.ladProviderEid });
            }
        }

        function prepareForServer() {
            if (this.ladProvider) {
                this.ladProviderEid = this.ladProvider.eId;
            }
        }
    }
})();
